var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-common-top'),_c('div',{staticClass:"limit-box"},[_c('v-address-add',{attrs:{"address_id":_vm.id,"business":_vm.business},on:{"callback":_vm.saved}})],1),_c('v-copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }